"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SubmitButton = function (_a) {
    var cryptoCurrency = _a.cryptoCurrency, cryptoNetwork = _a.cryptoNetwork, method = _a.method, loading = _a.loading, currencySettings = _a.currencySettings, isEnabled = _a.isEnabled, amount = _a.amount, balance = _a.balance;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var isSubmitButtonDisabled = (0, react_1.useMemo)(function () {
        var _a;
        if (!isEnabled)
            return true;
        if (method.name === 'crypto-currency' &&
            (!cryptoCurrency || !cryptoNetwork))
            return true;
        if (currencySettings &&
            balance &&
            (Number((balance === null || balance === void 0 ? void 0 : balance.amount) || 0) < Number(currencySettings.min) ||
                Number((balance === null || balance === void 0 ? void 0 : balance.amount) || 0) < amount))
            return true;
        //@ts-ignore
        var errorsCount = (_a = Object.keys(formState === null || formState === void 0 ? void 0 : formState.errors)) === null || _a === void 0 ? void 0 : _a.length;
        if (!formState.touched || errorsCount > 0)
            return true;
    }, [
        currencySettings,
        balance,
        formState.errors,
        formState.touched,
        cryptoCurrency,
        cryptoNetwork,
        amount,
    ]);
    return (react_1.default.createElement("div", { style: { marginTop: '20px' } },
        react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", color: "primary", text: "upper", loading: loading, height: "44px", maxWidth: "100%", className: "".concat(styles_module_scss_1.default.container, " ").concat(loading ? styles_module_scss_1.default.loading : ''), disabled: isSubmitButtonDisabled }, t('submit'))));
};
exports.default = SubmitButton;
